import type { useT } from "@repo/transifex";

type Translate = ReturnType<typeof useT>;

export function getPrinterErrorMessage(code: string, t: Translate) {
  switch (code) {
    case "connection_error":
      return t(
        "Printer has lost connection, please check printer and try reconnecting"
      );
    case "cutter_error":
      return t(
        "Cutter Error found on printer, please check printer and try again"
      );
    case "cover_open":
      return t("Printer cover is open, please close the cover and try again");
    case "paper_empty":
      return t("Printer paper is empty, please refill paper and try again");
    case "paper_jam_error":
      return t(
        "Paper Jam Error found on printer, please check printer and try again"
      );
    case "paper_separator_error":
      return t(
        "Paper Separator Error found on printer, please check printer and try again"
      );
    case "roll_position_error":
      return t(
        "Roll Position Error found on printer, please check printer and try again"
      );
    case "not_connected":
      return t(
        "Printer is not connected, please reconnect the printer in Settings and try again"
      );
    case "in_use":
      return t(
        "Printer is in use by another device, please disconnect it there and try again"
      );
    case "interface_unavailable":
      return t(
        "Printer connection is unavailable, please check the USB cable or Bluetooth and try again"
      );
    case "bluetooth_permission_denied":
      return t(
        "Bluetooth permission is missing, please allow Bluetooth for Kanpla POS in the device settings and try again"
      );
    case "paper_holding":
      return t("Printer is holding a receipt, please remove it and try again");
    case "print_head_overheated":
      return t("Printer is overheated, please wait a moment and try again");
    case "hardware_error":
      return t(
        "Hardware Error found on printer, please restart the printer and try again"
      );
    default:
      return t(
        "Unknown Error found on printer, please check printer and try again"
      );
  }
}
